document.addEventListener("DOMContentLoaded", function () {

	// ================================
	// Mobile toggle
	// ================================
	const mobileToggle = document.querySelector(".mobile-toggle");
	const navMenu = document.querySelector(".nav-menu");
	const mainNav = document.querySelector(".main-nav");


	mobileToggle.addEventListener("click", () => {
		mainNav.classList.toggle("menu-open");
		navMenu.classList.toggle("active");
		mobileToggle.setAttribute(
			"aria-expanded",
			navMenu.classList.contains("active")
		);
	});

	// ================================
	// Mobile dropdowns
	// ================================
	const dropdowns = document.querySelectorAll(".dropdown-toggle");

	dropdowns.forEach((btn) => {
		btn.addEventListener("click", function (e) {
			if (window.innerWidth <= 1200) {
				e.preventDefault();
				this.nextElementSibling.classList.toggle("active");
			}
		});
	});

	// ================================
	// Desktop nav dropdowns
	// ================================
	const desktopNavItems = document.querySelectorAll('.nav-menu-desktop .menu-item-has-children');
	const desktopNav = document.querySelector('.nav-menu-desktop');


	desktopNavItems.forEach((item) => {
		const toggle = item.querySelector('a');

		toggle.addEventListener('click', function(e) {
			const isOpen = item.classList.contains('is-open');

			// Close all first
			desktopNavItems.forEach((other) => {
				other.classList.remove('is-open');
			});

			if (!isOpen) {
				// First click — open dropdown, don't navigate
				e.preventDefault();
				item.classList.add('is-open');
			}
			// Second click — isOpen was true, fall through and navigate
		});
	});

	// Close desktop dropdowns on outside click
	document.addEventListener('click', function(e) {
		if (!e.target.closest('.nav-menu-desktop')) {
			desktopNavItems.forEach((item) => {
				item.classList.remove('is-open');
			});
		}
	});

	//sticky nav
	const observer = new IntersectionObserver(
		([entry]) => {
			desktopNav.classList.toggle('is-fixed', !entry.isIntersecting);
		},
		{ threshold: 0 }
	);

	observer.observe(mainNav);

});